import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { fadeIn, fadeOut, slideDown, slideUp } from 'src/app/animations';
import { DeficiencyItem } from 'src/app/models/deficiencies/deficiency-item.model';
import { Deficiency } from 'src/app/models/deficiencies/deficiency.model';
import { ActionsPlaceholderSettings } from 'src/app/models/enum/actions-placeholder-settings.enum';
import { JobStatusTypes } from 'src/app/models/enum/job-status-types.enum';
import { PageType } from 'src/app/models/enum/page-type.enum';
import { ServiceContractJobType } from 'src/app/models/enum/service-contract-job-type.enum';
import { Job } from 'src/app/models/job.model';
import { BitwiseHelper } from 'src/app/services/helpers/bitwise.helper';
import { AccountsService } from 'src/app/services/ui/accounts.service';
import { GlobalSettingsService } from 'src/app/services/ui/global-settings.service';
import { SettingsPreferences } from 'src/app/services/ui/models/settings-preferences.model';
import { ButtonIcons } from '../action-button/models/button-icons.enum';
import { LoginRedirectPage } from '../login-wizard/models/login-redirect-page.enum';
import moment from 'moment';
import { UserAccountInfo } from 'src/app/models/user-account-info.model';
import { JwtHelperService } from '@auth0/angular-jwt';
import { AuthPage } from 'src/app/models/auth/auth-page.model';

@Component({
	selector: 'deficiencies',
	templateUrl: './deficiencies.component.html',
	styleUrls: ['./deficiencies.component.scss', '../stylesheets/job-actions.scss', '../stylesheets/job-main.scss', '../stylesheets/job-inputs.scss'],
	animations: [slideUp(100), slideDown(100), fadeIn(200), fadeOut(200)]
})
export class DeficienciesComponent implements OnInit, AfterViewInit, OnDestroy {


	public self = this;

	public isLoading = false;

	public siteNotesUrl: string;
	public myWorkUrl: string;
	public allowDeficiencies: boolean;

	public deficiencies: DeficiencyItem[] = [];
	public sites: { name: string, siteId: number }[] = [];

	public userAccountInfoModel: UserAccountInfo;
	public accountRouteUrls: Map<AuthPage, string>;

	public deficiencyFormGroup: FormGroup;

	public readonly ButtonIcons = ButtonIcons;
	public readonly moment = moment;

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private accountsService: AccountsService,
		private jwt: JwtHelperService
	) {
		this.deficiencies = this.route.snapshot.data.deficiencies || [];
		this.userAccountInfoModel = this.route.snapshot.data.accountInfo as UserAccountInfo;
		this.allowDeficiencies = !this.userAccountInfoModel.isVendorUser || (this.userAccountInfoModel.isVendorUser && this.userAccountInfoModel.isSelfPerform);
		this.accountRouteUrls = this.route.snapshot.data.accountRouteUrls;
	}

	ngOnInit(): void {

		this.deficiencyFormGroup = new FormGroup({
			site: new FormControl(),
			isEmergency: new FormControl(false),
			isNotifyOther: new FormControl(false),
			comment: new FormControl(),
			isRequireCompletion: new FormControl(false),
			assignedTo: new FormControl()
		});

		this.injectActionButtons();
	}

	ngAfterViewInit(): void {
		GlobalSettingsService.isGlobalLoaderLoading = false;
		GlobalSettingsService.isSecondaryLoaderLoading = false;
	}

	ngOnDestroy(): void {
		GlobalSettingsService.navigationBarActions.clear();
	}

	public addDeficiency(): void {
		const model = this.deficiencyFormGroup.getRawValue();

		model.siteId = model.site.siteId;

		console.log(model);
		// Add site note
	}

	public redirectToDeficiency(deficiency: DeficiencyItem): void {
		this.router.navigate(['/' + deficiency.urlHash]);
	}

	private injectActionButtons(): void {
		const userData = this.jwt.decodeToken();

		GlobalSettingsService.navigationBarActions.set(
			'deficiencies_switch_account',
			{
				action: () => this.router.navigate(
					['/login'],
					{ queryParams: { email: userData?.email || '', page: LoginRedirectPage.Deficiencies, useMobile: true } }
				),
				text: 'Switch Account',
				isInDropdownMenu: false,
				isTextOnlyShownInDropdown: true,
				icon: 'sync_alt',
				listOrder: 1
			}
		);
		GlobalSettingsService.navigationBarActions.set(
			'my-work-access-button',
			{
				icon: 'list_alt',
				listOrder: 2,
				text: 'My Work',
				isInDropdownMenu: false,
				isTextOnlyShownInDropdown: true,
				action: () => this.router.navigate(['/', ...this.accountRouteUrls.get(AuthPage.MyWork).split('/')])
			}
		);
		if (this.allowDeficiencies) {
			GlobalSettingsService.navigationBarActions.set(
				'deficiencies-access-button',
				{
					icon: 'deficiencies',
					listOrder: 3,
					isCustomSvgIcon: true,
					text: 'Deficiencies',
					isInDropdownMenu: false,
					isTextOnlyShownInDropdown: true,
					action: () => this.router.navigate(['/', ...this.accountRouteUrls.get(AuthPage.Deficiencies).split('/')])
				}
			);

			GlobalSettingsService.navigationBarActions.set(
				'site-notes-access-button',
				{
					icon: 'site_notes',
					isCustomSvgIcon: true,
					listOrder: 4,
					text: 'Site Notes',
					isInDropdownMenu: false,
					isTextOnlyShownInDropdown: true,
					action: () => this.router.navigate(['/', ...this.accountRouteUrls.get(AuthPage.SiteNotes).split('/')])
				}
			);
		}
	}
}
